import { createSelector } from "reselect";
import { RootState } from "../../../redux/store";
import { IUsersState, UsersState } from "../types/users-state.interface";
import Store from "../../../redux/store";
import * as actions from "./users.actions";
import { UsersSearchForm } from "../types/users-search-form.interface";

export const getUsersState = (state: RootState) => state.users;

export const getUsers = createSelector(getUsersState, (state: UsersState) => state.allUsers);

export const selectUsersResults = createSelector(
  getUsersState,
  (state: UsersState) => state.allUsers || []
);

export const getSearchResults = createSelector(
  getUsersState,
  (state: UsersState) => state.searchResults
);

export function searchUsers(searchForm: UsersSearchForm) {
  Store.dispatch(actions.searchUsers(searchForm));
}

export function resetSearchResults() {
  Store.dispatch(actions.resetSearchResults());
}

export const selectUsersNameById = (userId: number) => ({ users: { allUsers } }: IUsersState) => {
  const user = allUsers?.find((u: any) => u.id === userId);
  return user ? `${user.firstName} ${user.lastName}` : null;
};

export const selectUserById = (userId: number) => ({ users: { allUsers } }: IUsersState) => {
  return allUsers?.find((u: any) => u.id === userId);
};
